import { styled } from 'stitches.config'
import { Stack } from 'components/Stack'
import Image from 'next/image'

export const ProductCardRoot = styled(Stack, {
  width: '280px',
  height: '452px',
  padding: '$4',
  backgroundColor: '$accent-white',
  border: '1px solid $secondary-600',
  borderRadius: '$4',

  '@bp2': {
    width: '268px',
  },
})

export const Data = styled(Stack, {
  flex: 1,
})

export const Chip = styled('div', {
  display: 'inline-flex',
  alignItems: 'center',
  padding: 'calc($1/2) $2 ',
  backgroundColor: '$primary-100',
  borderRadius: '$3',
  border: 'none',
})
